<design-slide-up-card [isCardOpen]="!!isCardOpen" [showBackgroundImage]="true" [hideHeaderInDesktop]="true"
  [showLogoInHeader]="true" class="route-planner-planning-result" [class]="direction" [roleDialog]="true"
  [dialogAriaLabel]="routeDetailsText">
  <!--
    a11y: same pattern as the rest of the result slide-ups - on mobile pull
    initial focus to the back/close chevron so SR users land on a labelled
    button when this fullscreen dialog opens. Outer OverlayComponent focus
    trap keeps Tab inside the dialog regardless of the initial target.
  -->
  <app-results-header [focusInitialOnBack]="!!isMobile" (onBackClick)="closeCard()" [class]="direction">
    <ng-container buttons>
      <!-- <mot-button type="button" matType="icon" icon="print" buttonClass="!text-xl !bg-transparent" /> -->
      <mot-button type="button" icon="share-nodes" buttonClass="!text-white !bg-transparent" iconClass="!text-2xl"
        [text]="shareRouteText" (onClick)="shareResults()" ariaHaspopup="dialog" />

      <mot-menu [menuVert]="false" [menuItems]="moreActionsMenuItems" [menuButtonAriaLabel]="moreActionsMenuText"
        dir="rtl" buttonClass="!rounded-xl !text-white !bg-transparent !w-8 !h-8 !min-w-0"
        buttonActiveClass="!rounded-xl !bg-white !w-8 !h-8 !min-w-0 !text-[#0C3058]" />
    </ng-container>

    <div content class="flex flex-col gap-2">
      <app-addresses-details [origin]="data.formValues.origin.addressDetails?.label"
        [destination]="data.formValues.destination.addressDetails?.label"
        [stop]="data.formValues.stop?.addressDetails?.label" [leg]="data.leg?.addressDetails?.label"
        [asRouteSummaryHeading]="true" />

      <span class="flex gap-2 items-center text-base">
        <ng-icon class="text-primary-300 text-2xl" name="clock" />
        <span class="font-normal !text-base text-white">
          {{ routeDurationText }}: {{ calculatedDurationText }}
        </span>
      </span>

      @if (!!showRoutePrice && !!selectedProfile) {
      <app-tariff-profile-price [selectedProfile]="selectedProfile" [prices]="data.route.travelSummary.price"
        [isInHeader]="true" />
      }
    </div>
  </app-results-header>

  <div class="bg-white rounded-t-xl flex-1 overflow-hidden min-h-0 min-w-0 max-w-full" id="printableArea">
    @if (!!isMobile) {
    <mat-tab-group dir="rtl" mat-stretch-tabs="false" dynamicHeight="false" [disableRipple]="true"
      class="bg-white h-full min-w-0 max-w-full rounded-t-xl use-padding">
      <mat-tab>
        <ng-template mat-tab-label>{{ routeDetailsText }}</ng-template>
        <div class="max-h-full min-w-0 max-w-full flex flex-col overflow-x-hidden">
          <app-detailed-result-buttons [buttons]="resultButtons" />

          <div class="results p-4 flex justify-between items-center min-w-0" [class]="direction">
            <mot-slide-toggle [value]="showRoutePrice" (onToggleChange)="togglePriceCalculation()"
              [label]="priceCalculationLabel" [dir]="direction" />
            <mot-select appearance="outline" [options]="tariffProfiles" class="!w-36 small shrink-0"
              [formControl]="priceProfileFormControl" [textAlign]="'end'" [ariaLabel]="tariffProfileLabel" />
          </div>
          <app-source-destination-detailed-result-route [route]="data.route" [formValues]="data.formValues"
            [leg]="data.leg" class="min-w-0 max-w-full flex-1 overflow-x-hidden overflow-y-auto use-scrollbar" />
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>{{ showOnMapText }}</ng-template>
        <ng-template matTabContent>
          <app-source-destination-results-map />
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    } @else {
    <div class="max-h-full min-w-0 max-w-full flex flex-col overflow-x-hidden h-full">
      <app-detailed-result-buttons [buttons]="resultButtons" />

      <div class="results p-4 flex justify-between items-center min-w-0" [class]="direction">
        <mot-slide-toggle [value]="showRoutePrice" (onToggleChange)="togglePriceCalculation()"
          [label]="priceCalculationLabel" [dir]="direction" />
        <mot-select appearance="outline" [options]="tariffProfiles" class="!w-36 small shrink-0"
          [formControl]="priceProfileFormControl" [textAlign]="'end'" [ariaLabel]="tariffProfileLabel" />
      </div>
      <app-source-destination-detailed-result-route [route]="data.route" [formValues]="data.formValues"
        [leg]="data.leg" class="min-w-0 max-w-full flex-1 overflow-x-hidden overflow-y-auto use-scrollbar" />
    </div>
    }
  </div>
</design-slide-up-card>